{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -130.68985336954378,
              54.7170016887593
            ],
            [
              -133.7270038704749,
              54.10563345983482
            ],
            [
              -131.55894185429892,
              50.06378732252435
            ],
            [
              -124.6111631728173,
              48.44822270699515
            ],
            [
              -122.94663216224788,
              48.166103638823216
            ],
            [
              -122.90887283738311,
              48.782728461373864
            ],
            [
              -122.66533421544057,
              48.98465898275495
            ],
            [
              -119.17659626380262,
              48.99504702770696
            ],
            [
              -114.1969661784866,
              49.068326186672806
            ],
            [
              -119.6499067340923,
              53.53331723021856
            ],
            [
              -119.92408689442937,
              59.973610084010375
            ],
            [
              -138.9753325118095,
              60.027231622044326
            ],
            [
              -137.6078062648365,
              59.02415687332319
            ],
            [
              -135.37945850834245,
              59.79683856995652
            ],
            [
              -133.570392777889,
              58.625503630411146
            ],
            [
              -131.82325770707143,
              56.64902704912831
            ],
            [
              -130.0023954568602,
              56.04269148442978
            ],
            [
              -129.8990977129143,
              55.23115932298822
            ],
            [
              -130.68985336954378,
              54.7170016887593
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}